// extracted by mini-css-extract-plugin
export default {"laptopBreakpoint":"1024px","tabletBreakpoint":"768px","mobileBreakpoint":"480px","content-width":"block_content-width__HEbJz","block":"block_block__tv8pP"};